export default __webpack_public_path__ + "static/media/700-800.bc97fbe4.jpg";